"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnterPhoneNumberContainer = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _ContentLayout = require("../../../../components/ContentLayout");
var _FieldGroupLayout = require("../../../../components/FieldGroupLayout");
var _PhoneField = require("../../../../components/PhoneField");
var _registration = require("../../../../actions/registration");
var _view = require("../../../../actions/view");
var _validation = require("../../../../utils/validation");
var _selectors = require("./selectors");
var _keyCodes = require("../../../../types/keyCodes");
var _view2 = require("../../../../types/view");
var _sentEmail = require("../../../../types/sentEmail");
var _tracking = require("../../tracking");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const EnterPhoneNumberContainer = _ref => {
  let {
    useSelector,
    useDispatch
  } = _ref;
  const dispatch = useDispatch();
  const phoneError = useSelector(_selectors.phoneErrorSelector);
  const hasAsyncPhoneError = useSelector(_selectors.hasPhoneErrorSelector);
  const login = useSelector(_selectors.viewStateEmailSelector);

  // FORM
  const [changed, setChanged] = React.useState(false);
  const [touched, setTouched] = React.useState(false);

  // PHONE
  const phoneRef = React.useRef(null);
  const [phone, setPhone] = React.useState('');
  const isPhoneInvalid = React.useMemo(() => !(0, _validation.isValidPhone)(phone), [phone]);
  const handlePhoneChange = value => {
    setPhone(value);
    setChanged(true);
  };

  // SUBMITION
  const handleFocusInvalid = React.useCallback(() => {
    if (isPhoneInvalid && phoneRef.current) {
      phoneRef.current.focus();
      return;
    }
  }, [isPhoneInvalid]);
  const handleSubmit = React.useCallback(() => {
    setTouched(true);
    (0, _tracking.trackButtonClick)('continue');
    if (isPhoneInvalid) {
      handleFocusInvalid();
      return;
    }
    dispatch((0, _registration.sendSms)({
      email: login,
      phone
    }));
    setChanged(false);
  }, [isPhoneInvalid, _registration.sendSms]);
  const handlePreventSubmit = React.useCallback(e => {
    e.preventDefault();
  }, []);
  const handleSubmitOnEnter = React.useCallback(e => {
    if (e.keyCode === _keyCodes.EKeyCode.Enter) {
      handleSubmit();
    }
  }, [handleSubmit]);
  const handleSkipClick = React.useCallback(() => {
    (0, _tracking.trackButtonClick)('add_later');
    dispatch((0, _view.changeView)(_view2.EActiveView.EmailSent, {
      type: _sentEmail.ESentEmailType.Registration,
      email: login
    }));
  }, [_view.changeView]);
  React.useEffect(() => {
    setPhone('');
  }, []);
  return /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handlePreventSubmit
  }, /*#__PURE__*/React.createElement(_FieldGroupLayout.FormFieldGroupLayout, {
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_PhoneField.PhoneField, {
      id: "tel",
      name: "tel",
      autoComplete: "tel",
      placeholder: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
      value: phone,
      inputRef: phoneRef,
      invalid: touched && (isPhoneInvalid || !changed && hasAsyncPhoneError),
      onValueChange: handlePhoneChange,
      onKeyDown: handleSubmitOnEnter,
      errorMessage: phoneError
    })),
    buttons: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "ContinueAuthBtn",
      onClick: handleSubmit,
      fullWidth: true
    }, "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(_uiKit.Button, {
      "data-name": "SwitchToPhoneAuthBtn",
      theme: "fill_secondary",
      onClick: handleSkipClick,
      fullWidth: true
    }, "\u0414\u043E\u0431\u0430\u0432\u043B\u044E \u043F\u043E\u0437\u0436\u0435"))
  })));
};
exports.EnterPhoneNumberContainer = EnterPhoneNumberContainer;